import { render, staticRenderFns } from "./wh12.vue?vue&type=template&id=4ec244a7&scoped=true&"
import script from "./wh12.vue?vue&type=script&lang=js&"
export * from "./wh12.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&id=4ec244a7&prod&scoped=true&lang=css&"
import style1 from "./wh12.vue?vue&type=style&index=1&id=4ec244a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec244a7",
  null
  
)

export default component.exports